import { createBrowserRouter, Navigate } from "react-router-dom";
import AssetManagement from "./pages/asset-management/AssetManagement";
import LNDManagement from "./pages/learning-development/index";
import Setting from "./pages/setting/index";
import RequestTab from "./pages/asset-management/tabs/RequestTab";
import AssetTab from "./pages/asset-management/tabs/AssetTab";
import SettingTab from "./pages/asset-management/tabs/SettingTab";
import ExitManagement from "./pages/exit-management/ExitManagement";
import ExitManagementRoot from "./pages/exit-management/ExitManagementRoot";
import ApplyResignation from "./pages/exit-management/ApplyResignation";
import PrivateRoute from "./components/route/PrivateRoute";
import ViewResignation from "./pages/exit-management/ViewResignation";
import ExitRequestTab from "./pages/exit-management/tabs/RequestTab";
import ExitNocRequestTab from "./pages/exit-management/tabs/NocRequestTab";
import ExitNocApprovalTab from "./pages/exit-management/tabs/NocApprovalTab";
import ExitSettingTab from "./pages/exit-management/tabs/SettingTab";
import RequestDetails from "./pages/asset-management/tabs/RequestDetails";
import HierarchyPage from "./pages/organization-hierarchy/HierarchyPage";
import TimesheetPage from "./pages/timesheet/TimesheetPage";
import TimesheetRoot from "./pages/timesheet/TimesheetRoot";
import TimesheetForm from "./pages/timesheet/TimesheetForm";
import GrievancePage from "./pages/grievance/GrievancePage";
import GrievanceRoot from "./pages/grievance/GrievanceRoot";
import GrievanceDetails from "./pages/grievance/GrievanceDetails";
import OddRoot from "./pages/odd/OddRoot";
import OddPage from "./pages/odd/OddPage";
import OddForm from "./pages/odd/OddForm";
import WfhRoot from "./pages/wfh/WfhRoot";
import WfhPage from "./pages/wfh/WfhPage";
import WfhForm from "./pages/wfh/WfhForm";
import LabourLawPage from "./pages/labour-law/LabourLawPage";
import LabourLawRoot from "./pages/labour-law/LabourLawRoot";
import { useNavigate } from "react-router-dom";
import LearningDashboardTab from "./pages/learning-development/tab/DashboardTab";
import CreateProgram from "./pages/learning-development/internal-learning/programs/CreateProgram";
import LearningProgramLayout from "./pages/learning-development/internal-learning/programs";
import LearningProgramList from "./pages/learning-development/internal-learning/programs/LearningProgramList";
import ProgramCategoriesLayout from "./pages/learning-development/internal-learning/program-category";
import ProgramCategoryList from "./pages/learning-development/internal-learning/program-category/ProgramCategoryList";
import CreateCategory from "./pages/learning-development/internal-learning/program-category/create-category";
import ProgramAssignLayout from "./pages/learning-development/internal-learning/assign-program";
import ProgramAssignList from "./pages/learning-development/internal-learning/assign-program/ProgramAssignList";
import ProgramRequestLayout from "./pages/learning-development/external-learning/program-request";
import ProgramRequestList from "./pages/learning-development/external-learning/program-request/ProgramRequestList";
import UserProgramRequestLayout from "./pages/learning-development/external-learning/user-program-request";
import UserProgramRequestList from "./pages/learning-development/external-learning/user-program-request/UserProgramRequestLIst";
import LearningProgramUserLayout from "./pages/learning-development/internal-learning/user";
import LearningProgramListUser from "./pages/learning-development/internal-learning/user/LearningProgramListUser";
import TutorialPage from "./pages/learning-development/internal-learning/user/TutorialPage";
import BudgetSettingsLayout from "./pages/learning-development/setting";
import BudgetSettings from "./pages/learning-development/setting/BudgetSettings";
import CustomFieldLayout from "./pages/setting/custom-field";
import CustomFieldList from "./pages/setting/custom-field/CustomFieldList";
import MailTemplateLayout from "./pages/setting/mail-template";
import MailTemplatePage from "./pages/setting/mail-template/MailTemplatePage";
import ComplianceMasterLayout from "./pages/setting/compliance-master";
import PTMasterLayout from "./pages/setting/compliance-master/pt-master";
import PTMasterList from "./pages/setting/compliance-master/pt-master/PTMasterList";
import AddEditPTMaster from "./pages/setting/compliance-master/pt-master/AddEditPTMaster";

import LWFMasterLayout from "./pages/setting/compliance-master/lwf-master";
import LWFMasterList from "./pages/setting/compliance-master/lwf-master/LWFMasterList";
import AddEditLWFMaster from "./pages/setting/compliance-master/lwf-master/AddEditLWFMaster";

import MinimumWagesLayout from "./pages/setting/compliance-master/minimum-wages";
import MinimumWagesList from "./pages/setting/compliance-master/minimum-wages/MinimumWagesList";
import AddEditMinimumWages from "./pages/setting/compliance-master/minimum-wages/AddEditMinimumWages";

import GrievanceCategorySetting from "./pages/setting/grievance-setting/GrievanceCategorySetting";

import CompliancePage from "./pages/compliance/CompliancePage";
import ComplianceGeneratePage from "./pages/compliance/ComplianceGeneratePage";
import ComplianceRoot from "./pages/compliance/ComplianceRoot";
import GlobalPayroll from "./pages/global-payroll/GlobalPayroll";
import PayBasisList from "./pages/global-payroll/pay-basis/PayBasisList";
import WageRateList from "./pages/global-payroll/wage-rates/WageRateList";
import PayrollTemplateList from "./pages/global-payroll/payroll-templates/PayrollTemplateList";
import PayrollRunsList from "./pages/global-payroll/payroll-runs/PayrollRunsList";
import MonthlyParityList from "./pages/global-payroll/monthly-parity/MonthlyParityList";
const router = createBrowserRouter([
  {
    path: "/asset-management",
    element: <AssetManagement />,
    children: [
      {
        index: true,
        element: <RequestTab />,
      },
      {
        path: "requests",
        element: <RequestTab />,
      },
      {
        path: "assets",
        element: <AssetTab />,
      },
      {
        path: "setting",
        element: (
          <PrivateRoute
            element={<SettingTab />}
            requiredRoles={[1, 2, 8, 9]}
            fallback="/asset-management/requests"
          />
        ),
      },
    ],
  },
  {
    path: "/asset-management/request-details/:requestId",
    element: <RequestDetails />,
  },
  // Exit Management Routes
  {
    path: "/exit-management",
    element: <ExitManagementRoot />,
    children: [
      {
        element: <ExitManagement />,
        children: [
          {
            index: true,
            element: <ExitRequestTab />,
          },
          {
            path: "requests",
            element: <ExitRequestTab />,
          },
          {
            path: "noc-requests",
            element: (
              <PrivateRoute
                element={<ExitNocRequestTab />}
                requiredRoles={[1, 2]}
                fallback="/exit-management/requests"
              />
            ),
          },
          {
            path: "noc-approvals",
            element: <ExitNocApprovalTab />,
          },
          {
            path: "setting",
            element: (
              <PrivateRoute
                element={<ExitSettingTab />}
                requiredRoles={[1, 2]}
                fallback="/exit-management/requests"
              />
            ),
          },
        ],
      },
      {
        path: "apply-resignation",
        element: (
          <PrivateRoute
            element={<ApplyResignation />}
            requiredRoles={[7]}
            fallback="/exit-management"
          />
        ),
      },
      {
        path: "view-resignation/:resignationId",
        element: <ViewResignation />,
      },
    ],
  },
  // organization hierarchy Routes
  {
    path: "/organization-hierarchy",
    element: <HierarchyPage />,
  },
  // Grievance Routes
  {
    path: "/grievance",
    element: <GrievanceRoot />,
    children: [
      {
        index: true,
        element: <GrievancePage />,
      },
      {
        path: "details/:grievanceId",
        element: <GrievanceDetails />,
      },
      {
        // Reports became the Dashboard tab on the Grievance page.
        path: "reports",
        element: <Navigate to="/grievance" replace />,
      },
    ],
  },
  // Timesheet Routes
  {
    path: "/timesheet",
    element: <TimesheetRoot />,
    children: [
      {
        index: true,
        element: <TimesheetPage />,
      },
      {
        path: "add-timesheet",
        element: (
          <PrivateRoute
            element={<TimesheetForm />}
            requiredRoles={[7]}
            fallback="/timesheet"
          />
        ),
      },
      {
        path: "edit-timesheet/:timesheetId",
        element: (
          <PrivateRoute
            element={<TimesheetForm />}
            requiredRoles={[7]}
            fallback="/timesheet"
          />
        ),
      },
    ],
  },
  {
    path: "/odd",
    element: <OddRoot />,
    children: [
      {
        index: true,
        element: <OddPage />,
      },
      {
        path: "apply",
        element: (
          <PrivateRoute
            element={<OddForm />}
            requiredRoles={[7]}
            fallback="/odd"
          />
        ),
      },
      {
        path: "edit/:oddId",
        element: (
          <PrivateRoute
            element={<OddForm />}
            requiredRoles={[7]}
            fallback="/odd"
          />
        ),
      },
    ],
  },
  {
    path: "/wfh",
    element: <WfhRoot />,
    children: [
      {
        index: true,
        element: <WfhPage />,
      },
      {
        path: "apply",
        element: (
          <PrivateRoute
            element={<WfhForm />}
            requiredRoles={[7]}
            fallback="/wfh"
          />
        ),
      },
      {
        path: "edit/:wfhId",
        element: (
          <PrivateRoute
            element={<WfhForm />}
            requiredRoles={[7]}
            fallback="/wfh"
          />
        ),
      },
    ],
  },
  // Labour Law Routes
  {
    path: "/labour-law",
    element: (
      <PrivateRoute
        element={<LabourLawRoot />}
        requiredRoles={[1, 2]}
        fallback="/"
      />
    ),
    children: [
      {
        index: true,
        element: <LabourLawPage />,
      },
    ],
  },
  {
    path: "/learning-and-development",
    element: <LNDManagement />,
    children: [
      {
        index: true,
        element: <LearningDashboardTab />,
      },
      {
        path: "dashboard",
        element: <LearningDashboardTab />,
      },
      {
        path: "program-categories",
        element: <ProgramCategoriesLayout />,
        children: [
          {
            index: true,
            element: <ProgramCategoryList />,
          },
          {
            path: "create",
            element: <CreateCategory />,
          },
        ],
      },
      {
        path: "learning-program",
        element: <LearningProgramLayout />,
        children: [
          {
            index: true,
            element: <LearningProgramList />,
          },
          {
            path: "create",
            element: <CreateProgram />,   // CREATE
          },
          {
            path: "edit/:id",
            element: <CreateProgram />,   // EDIT (same component)
          },
        ],
      },
      {
        path: "assign-program",
        element: <ProgramAssignLayout />,
        children: [
          {
            index: true,
            element: <ProgramAssignList />,
          },
        ]
      },
      {
        path: "program-request",
        element: <ProgramRequestLayout />,
        children: [
          {
            index: true,
            element: <ProgramRequestList />,
          },
        ]
      },
      {
        path: "user-program-request",
        element: <UserProgramRequestLayout />,
        children: [
          {
            index: true,
            element: <UserProgramRequestList />,
          },
        ]
      },
      {
        path: "user-learning-program",
        element: <LearningProgramUserLayout />,
        children: [
          {
            index: true,
            element: <LearningProgramListUser />,
          },
          {
            path: "tutorial/:program_id/:slug",
            element: <TutorialPage />,
          },
        ]
      },
      {
        path: "settings",
        element: <BudgetSettingsLayout />,
        children: [
          {
            index: true,
            element: <BudgetSettings />,
          },
        ]
      },
    ]
  },
  {
    path: "/setting",
    element: <Setting />,
    children: [
        {
            index: true,
            element: <CustomFieldLayout />,
        },

        {
            path: "custom-field",
            element: <CustomFieldList />,
        },

        {
          path: "mail-template",
          element: <MailTemplateLayout />,
          children: [
            {
              index: true,
              element: <MailTemplatePage />,
            },
          ],
        },

        
        // Compliance Master
        
        {
            path: "compliance-master",
            element: <ComplianceMasterLayout />,
            children: [

                // /setting/compliance-master
                // Default → PT Master
                {
                    index: true,
                    element: <PTMasterList />,
                },

                
                // PT Master
                
                {
                    path: "pt-master",
                    element: <PTMasterLayout />,
                    children: [
                        {
                            index: true,
                            element: <PTMasterList />,
                        },
                        {
                            path: "create",
                            element: <AddEditPTMaster />,
                        },
                        {
                            path: "edit/:id",
                            element: <AddEditPTMaster />,
                        },
                    ],
                },

                
                // LWF Master
                
                {
                    path: "lwf-master",
                    element: <LWFMasterLayout />,
                    children: [
                        {
                            index: true,
                            element: <LWFMasterList />,
                        },
                        {
                            path: "create",
                            element: <AddEditLWFMaster />,
                        },
                        {
                            path: "edit/:id",
                            element: <AddEditLWFMaster />,
                        },
                    ],
                },

                
                // Minimum Wages
                
                {
                    path: "minimum-wages",
                    element: <MinimumWagesLayout />,
                    children: [
                        {
                            index: true,
                            element: <MinimumWagesList />,
                        },
                        {
                            path: "create",
                            element: <AddEditMinimumWages />,
                        },
                        {
                            path: "edit/:id",
                            element: <AddEditMinimumWages />,
                        },
                    ],
                },
            ],
        },

        
        // Grievance Setting
        
        {
            path: "grievance-setting",
            element: <GrievanceCategorySetting />,
        },
    ],
},
  // Compliance Routes
  {
    path: "/compliances",
    element: (
      <PrivateRoute
        element={<ComplianceRoot />}
        requiredRoles={[1, 2]}
        fallback="/"
      />
    ),
    children: [
      {
        index: true,
        element: <CompliancePage />,
      },
      {
        path: "generate",
        element: <ComplianceGeneratePage />,
      }
    ],
  },
  // Global payroll route
  // Phase 0 of the new hourly/daily/weekly/bi-weekly payroll module: pay-basis
  // assignment + wage-rate master. Monthly payroll stays in CI4 for now.
  {
    path: "/global-payroll",
    element: (
      <PrivateRoute
        element={<GlobalPayroll />}
        requiredRoles={[1, 2, 4, 6]}
        fallback="/"
      />
    ),
    children: [
      {
        index: true,
        element: <PayBasisList />,
      },
      {
        path: "pay-basis",
        element: <PayBasisList />,
      },
      {
        path: "wage-rates",
        element: <WageRateList />,
      },
      {
        path: "payroll-templates",
        element: <PayrollTemplateList />,
      },
      {
        path: "payroll-runs",
        element: <PayrollRunsList />,
      },
      {
        path: "monthly-parity",
        element: <MonthlyParityList />,
      },
    ],
  }
]);
export default router;
